import styled, { theme } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const CenteredWidthContainer = styled.div.withConfig({
  displayName: "HorizontalLayoutContainer__CenteredWidthContainer",
  componentId: "sc-20liht-0"
})(["width:100%;max-width:", ";margin:0 auto;padding:0 12px;position:relative;z-index:0;"], ({
  $maxWidth
}) => $maxWidth);
const sizes = {
  medium: theme.sizes.PUBLIC_PAGE_WIDTH,
  large: theme.sizes.PUBLIC_PAGE_WIDTH_LARGE
};
const HorizontalLayoutContainer = ({
  children,
  size = 'medium'
}) => {
  return /*#__PURE__*/_jsx(CenteredWidthContainer, {
    $maxWidth: sizes[size],
    children: children
  });
};
export default HorizontalLayoutContainer;